// extracted by mini-css-extract-plugin
export default {"button":"qr_button__WITgA","button--danger":"qr_button--danger__J+UgF","button__icon":"qr_button__icon__YPBl9","rotate":"qr_rotate__jphpB","canvas":"qr_canvas__gOY7u"};